import { parseEntityId } from '../../entity'

export class CupoUtils {
  static parseFormToApiNewCupo (formValues) {
    return {
      cupo: {
        fechaDeEmision: formValues.fechaDeCupo,
        exportador: parseEntityId(formValues.exportador),
        cereal: formValues.cereal,
        cantidadAsignada: formValues.cantidad
      },
      tipo: formValues['Tipo de Cupo']
    }
  }

  static parseFormToApiRenominarCupo (formValues, currentCupo) {
    return {
      clave: {
        exportador: currentCupo.cuitExportador,
        cereal: currentCupo.claveCereal,
        cargador: currentCupo.cuitCargador,
        fecha_de_emision: currentCupo.fechaDeEmisionDate,
        corredor: currentCupo.cuitCorredor
      },
      valores: {
        exportador: currentCupo.cuitExportador,
        cereal: currentCupo.claveCereal,
        cargador: currentCupo.cuitCargador,
        fecha_de_emision: currentCupo.fechaDeEmisionDate,
        cantidad_asignada: formValues.cantidadRenominada,
        corredor: currentCupo.cuitCorredor
      }
    }
  }

  static parseFormToDeleteNomincacionCupo (currentCupo) {
    return {
      clave: {
        exportador: currentCupo.cuitExportador,
        cereal: currentCupo.claveCereal,
        cargador: currentCupo.cuitCargador,
        fecha_de_emision: currentCupo.fechaDeEmisionDate,
        corredor: currentCupo.cuitCorredor
      }
    }
  }

  static parseFormToApiNominarCupo (formValues, currentCupo) {
    return {
      cupo: {
        exportador: currentCupo.cuitExportador,
        cereal: currentCupo.claveCereal,
        fecha_de_emision: currentCupo.fechaDeEmision,
        cantidad_asignada: formValues.cantidadNominada,
        cargador: parseEntityId(formValues.remitenteComercial),
        corredor: parseEntityId(formValues.corredorComprador)
      },
      repetirHasta: formValues.repetirNominacionHasta
    }
  }

  static extractClaveFromCupoForm (cupo) {
    return {
      fecha_de_emision: cupo.fechaDeEmision,
      exportador: cupo.exportador,
      cereal: cupo.cereal
    }
  }

  static extractClaveFromCupo (cupo) {
    return {
      fecha_de_emision: cupo.fechaDeEmision,
      exportador: cupo.cuitExportador,
      cereal: cupo.claveCereal.trim()
    }
  }

  static parseTipoCupo (tipoShort) {
    return tipoShort === 'N' ? 'Nominable' : 'Libre'
  }

  static parseCupoToCupoVigente (cupo) {
    return {
      cantidadAsignada: cupo.cantidadAsignada,
      cereal: cupo.cereal.trim(),
      exportador: `${cupo.exportador}`,
      fechaDeEmision: cupo.fechaDeEmision
    }
  }
}
